import { createFileRoute } from '@tanstack/react-router';

import { MapView } from '@/components/map/components/MapView';
import { validateMapSearch } from '@/components/map/utils/mapUrlState';
import { MapInteractionProvider } from '@/map-interaction/MapInteractionProvider';
import { ExclusivePanelProvider } from '@/panels/ExclusivePanelProvider';

export const Route = createFileRoute('/savi/network-overview')({
    validateSearch: validateMapSearch,
    component: NetworkOverviewPage,
});

function NetworkOverviewPage() {
    // The SAVI map is interactive in production (AOI/DMA selection + stats card, DMA
    // search, side panels), so it gets the real providers — a production MapView must
    // never run on the no-op context fallbacks (those are for unit tests only).
    // StatsScope/MapActions/TableView are genuinely absent here (no stats bar, no
    // out-of-tree reset control, no table), so their fallbacks remain correct.
    return (
        <div className="absolute inset-0 overflow-hidden">
            <ExclusivePanelProvider>
                <MapInteractionProvider>
                    <MapView mode="savi" />
                </MapInteractionProvider>
            </ExclusivePanelProvider>
        </div>
    );
}
